<template>
  <div>
    <h2 class="text__bold text__center">Dashboard</h2>
    <div class="request--select">
      <div
        class="request--select-item tile pointer"
        v-for="type in getRequestCounts"
        :key="type.namespace"
        :class="{'select--active': type.namespace === namespace}"
        @click="setNamespace(type.namespace)"
      >
        <div class="select--icon">
          <font-awesome-icon :icon="type.icon" size="2x" class="icon" />
        </div>
        <p class="text__center text__bold">{{ type.title }} Requests</p>
        <p class="flex__between">
          <span class="text__bold">Total Requests:</span>
          <span>{{ type.count }}</span>
        </p>
        <p class="flex__between">
          <span class="text__bold">Incomplete Requests:</span>
          <span>{{ type.unfinishedCount }}</span>
        </p>
      </div>
    </div>
    <RequestsTile
      v-for="request in filteredRequests"
      :key="request.url"
      :title="request.name"
      :total="getRequestCount"
      :status-counts="getRequestStatusCounts"
      :chart-data="getChartData"
      :last-request="getLastRequest"
      :url="request.url"
    />
    <LicensesTile />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import RequestsTile from "./RequestsTile";
import LicensesTile from "./LicensesTile";
export default {
  components: {
    RequestsTile,
    LicensesTile
  },
  data() {
    return {
      namespace: "optOut"
    };
  },
  computed: {
    ...mapGetters(["getRequestTypes"]),
    getRequestCounts() {
      const requests = this.getRequestTypes.map(type => {
        const count = this.$store.getters[`${type.namespace}/getRequestCount`];
        const unfinishedCount = this.$store.getters[
          `${type.namespace}/getUnfinishedCount`
        ];
        return {
          title: type.name,
          namespace: type.namespace,
          count: count,
          unfinishedCount: unfinishedCount,
          icon: type.icon
        };
      });
      return requests;
    },
    getLastRequest() {
      return this.$store.getters[`${this.namespace}/getLastRequest`];
    },
    getRequestCount() {
      return this.$store.getters[`${this.namespace}/getRequestCount`];
    },
    getRequestStatusCounts() {
      return this.$store.getters[`${this.namespace}/getRequestStatusCounts`];
    },
    getChartData() {
      return this.$store.getters[`${this.namespace}/getChartData`];
    },
    filteredRequests() {
      return this.getRequestTypes.filter(request => {
        return request.namespace === this.namespace;
      });
    }
  },
  methods: {
    setNamespace(name) {
      this.namespace = name;
    }
  }
};
</script>

<style scoped lang="scss">
</style>